import React, { Fragment } from 'react';
import { ReactComponent as BrandIcon } from 'assets/icons/brand_icon.svg';
import { Link, useLocation } from 'react-router-dom';
import { RecentActivityType } from './types';
import moment from 'moment';

type Props = {
  data: RecentActivityType;
};
const RecentActivityCard = ({ data }: Props) => {
  const activityDate = data.created_at.split('T')[0];
  const date = moment(activityDate).format('MMM Do, YY');
  const activityTime = data.created_at.split('T')[1].split('.')[0];
  const time = moment(activityTime, 'HH:mm:ss').add(1, 'hours').format('hh:mm A');
  const splitActivity = data.activity.split(data.activity_name);

  const activityTypeurl = (activityType: string) => {
    const location = useLocation();
    const currentRoute = location.pathname;

    switch (activityType) {
      case 'brand':
        return `${['/brand', data.brand_id, 'details'].join('/')}`;
      case 'brand_working_hours':
        return `${['/brand', data.brand_id, 'details'].join('/')}`;
      case 'meal':
        return `${['/edit-meal', data.meal_id, 'brand-details'].join('/')}`;
      default:
        return currentRoute;
    }
  };

  return (
    <div className='flex gap-5 pb-8 brand_container_details pr-2'>
      <BrandIcon />
      <div className='brand_container_details_box'>
        <p className='text-xs font-normal'>
          <span className='bg-[#FEF0F2] rounded px-[6px] text-[#E60A2B] text-xs font-medium mr-1'>
            {data.activity_name}
          </span>
          {splitActivity[1]}
        </p>
        <p className='text-xs font-normal text-gray-5 mb-2'>
          {date}
          <span className='mx-1 text-base font-bold text-gray-5'>.</span>
          {time}
        </p>
        <div className='rounded-[6px] border border-[#EBEBEB] px-4 pt-3 pb-[14px] flex gap-3 min-w-[256px] max-w-[95%]'>
          <Fragment>
            <div className='w-[35px] h-[35px]'>
              {data.logo ? (
                <img
                  src={data.logo}
                  alt='brand logo'
                  className='w-full h-full rounded-full object-cover'
                />
              ) : (
                <div className='bg-gray-5 min-w-[35px] min-h-[35px] rounded-full'></div>
              )}
            </div>
            <div>
              <p className='text-sm font-medium mb-1'>{data.activity_name}</p>
              <p className='text-xs font-normal text-gray-5 mb-4'>{data.activity_description}</p>
              {data.activity_action !== 'delete' && (
                <Link to={activityTypeurl(data.activity_type)}>
                  <p className='text-[#E60A2B] text-xs underline underline-offset-4'>
                    View details
                  </p>
                </Link>
              )}
            </div>
          </Fragment>
        </div>
      </div>
    </div>
  );
};

export default RecentActivityCard;
